import { useState } from "react";
import useSessionState from "./useSessionState";

export default function useCollection(initialValue, getNewValue, name) {
    const [values, setValues] = useSessionState(initialValue, name);

    const handleAdding = () => {
        const newValues = [
            ...values,
            getNewValue(values.length)
        ];
        setValues(newValues);
    };

    const handleChanging = (index, name, value) => {
        values[index][name] = value;
        setValues([
            ...values
        ]);
    };

    const handleRemoving = (indexToRemove) => {
        setValues([
            ...values.filter((_, index) => index !== indexToRemove)
        ]);
    };

    const handleBulkAdd = (total) => {
        const newValues = [...values];
        for (let i = 0; i < total; i++) {
            newValues.push(getNewValue(newValues.length));
        }
        setValues(newValues);
    };

    const handleBulkRemove = (total) => {
        setValues([
            ...values.filter((_, index) => index < values.length - total)
        ]);
    }

    return { 
        values, 
        add: handleAdding,
        change: handleChanging,
        remove: handleRemoving,
        setValues,
        bulkAdd: handleBulkAdd,
        bulkRemove: handleBulkRemove 
    };
}